import { Content, generateJSON } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";

export function isContentEmpty(content: Content): boolean {
  if (content === null) {
    return true;
  }

  if (typeof content === "string") {
    return content === "";
  }

  if (Array.isArray(content)) {
    return content.every((item) => isContentEmpty(item));
  }

  if (!content.content) {
    return true;
  }

  return content.content.every((item) => !item.content);
}

export const checkIfContentEmpty = (value: string) => {
  let empty = true;
  try {
    const content = generateJSON(value, [StarterKit]);
    empty = isContentEmpty(content);
  } catch (err) {
    console.log(err);
  } finally {
    return empty;
  }
};
